import { ref, computed } from "vue";
import { guideService } from "../../../services/guideService";

export function useTimeTrackerGuides() {
  const showAddTaskGuide = ref(false);
  const ADD_TASK_GUIDE_ID = "add-task-guide";

  // Responsive guide text
  const addTaskGuideText = computed(() => {
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    if (isTouchDevice || isSmallScreen) {
      return "Tap to start planning your day";
    }
    return "Start planning your day";
  });

  function closeAddTaskGuide() {
    showAddTaskGuide.value = false;
  }

  function dismissAddTaskGuide() {
    guideService.dismissGuide(ADD_TASK_GUIDE_ID);
    showAddTaskGuide.value = false;
  }

  function showGuideIfNeeded(tasks: any[]) {
    if (tasks.length === 0 && guideService.shouldShowGuide(ADD_TASK_GUIDE_ID)) {
      setTimeout(() => {
        showAddTaskGuide.value = true;
      }, 500);
    } else if (tasks.length > 0) {
      // Hide guide when tasks are added
      showAddTaskGuide.value = false;
    }
  }

  function hideGuideOnAddTask() {
    // Hide the guide when user clicks Add Task button (but don't dismiss permanently)
    showAddTaskGuide.value = false;
  }

  function showGuideOnDialogClose(tasks: any[], isDialogOpen: boolean) {
    if (
      !isDialogOpen &&
      tasks.length === 0 &&
      guideService.shouldShowGuide(ADD_TASK_GUIDE_ID)
    ) {
      // Show guide again if dialog is closed and no tasks exist
      setTimeout(() => {
        showAddTaskGuide.value = true;
      }, 300);
    }
  }

  return {
    showAddTaskGuide,
    addTaskGuideText,
    closeAddTaskGuide,
    dismissAddTaskGuide,
    showGuideIfNeeded,
    hideGuideOnAddTask,
    showGuideOnDialogClose,
  };
}
